import { httpCall } from '../common/util';
let oapi =  `/${process.env.public_api_version}/`;
const getOrgId = () => $('#_co').val();
const getOrgHeader = () => `org${process.env.header_seperator}id`;

const getAssocaitePartyUrl= (data)=>
{
   let url="";
    if(data.type=="wrk")
    {
        url= `${oapi}workkard/associate_party/${data.eid}`;
    }
    else{
    url=`${oapi}activity/associate_party/${data.eid}`;
    }
    return url;
}

const getDeAssocaitePartyUrl= (data)=>
{
   let url="";
    if(data.type=="wrk")
    {
        url= `${oapi}workkard/disassociate_party/${data.eid}`;
    }
    else{
    url=`${oapi}activity/disassociate_party/${data.eid}`;
    }
    return url;
}


export const addParty = async (payload) => {
    const orgHeader = getOrgHeader();
    const org_id = getOrgId();
    var options = {
        method: 'POST',
        url:  `${oapi}party/new`,
        headers: {
            [orgHeader]: org_id
        },
        data: payload
    };
    return httpCall(options);
}

export const updateParty = async (payload) => {
    const orgHeader = getOrgHeader();
    const org_id = getOrgId();
    let partyId=payload.party.party_id;
    delete payload.party.party_id;
    var options = {
        method: 'PUT',
        url:  `${oapi}party/update/${partyId}`,
        headers: {
            [orgHeader]: org_id
        },
        data: payload
    };
    return httpCall(options);
}

export const associateParties = async (payload) => {
    const orgHeader = getOrgHeader();
    const org_id = getOrgId();
    var options = {
        method: 'PUT',
        url: getAssocaitePartyUrl(payload),
        headers: {
            [orgHeader]: org_id
        },
        data: {party_ids:[payload.pid]}
    };
    return httpCall(options);
}

export const deAssociateParty = async (payload) => {
    const orgHeader = getOrgHeader();
    const org_id = getOrgId();
    var options = {
        method: 'PUT',
        url: getDeAssocaitePartyUrl(payload),
        headers: {
            [orgHeader]: org_id
        },
        data: {party_ids:[payload.pid]}
    };
    return httpCall(options);
}